export default __webpack_public_path__ + "static/media/driver-slide3.effd49b6.jpg";